import { Avatar, AvatarGroup, Box, Button, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from "@mui/material";
import { forwardRef, useContext, useState } from "react";
import { isBrowser } from "react-device-detect";
import { deleteAPIAsync, getAPIAsync, postAPIAsync, putAPIAsync } from "../api/apiCalls";
import Provider from "../api/provider";
import { FOLLOWERS_LIMIT, icon, IMAGE_RESIZE_PATH, isNullOrEmpty, replaceEmojiSizeForInbox, returnFormattedMessage, SELLER_SITE_PATH, STORE_BUCKET_NAME, StoreStats, UniqueID, USER_BUCKET_NAME, UserStats, WEBSITE_PATH, windowPostMessage } from "../common/common";
import { Decrypt, Encrypt } from "../common/reacte2ee";
import { resource } from "../common/resource";
import { UserDetailsContext } from "../contexts/entityDetailsContext";
import { FollowingEntityInfo, LoggedInUserDetails, Reference, SuggestedResponse } from "../models/inbox";
import { ChatHistory } from "../models/messaging";
import { formatDate } from "./dateFormatter";
import CreateMenu from "./menu";
import { blockMenuItem, deleteMenuItem, muteMenuItem, pinMenuItem, unblockMenuItem, unmuteMenuItem, unpinMenuItem } from "./menuItems/chatMenuItems";
import { StyledBadgeActive, StyledBadgeNotification, StyledBadgeNotificationMute } from "./styledBadge";
import useLongPressMod from "./useLongPress";

interface propsListData {
  data: ChatHistory[] | FollowingEntityInfo[] | SuggestedResponse[] | null;
  type: string;
  state?: any;
  actionCallback?: any;
  connectivityStatus?: boolean | null;
  addArrData?: any;
  arrData?: ChatHistory[];
  secondaryActionWidth?: string;
}

const ListCards = ({ data, type, state, actionCallback, connectivityStatus, addArrData, arrData, secondaryActionWidth }: propsListData, ref?: any) => {
  const [messageAnchorElement, setMessageAnchorElement] = useState<any>();
  const [inboxMenuOptions, setInboxMenuOptions] = useState<any>();
  const [listIndex, setListIndex] = useState<number>(0);
  const [disableRipple, setDisableRipple] = useState<boolean>(false);
  const [clickedElement, setClickedElement] = useState<any>();
  const { userDetails } = useContext<any>(UserDetailsContext);
  let longPressEvent = {};

  if (!isBrowser && type === "chathistory") {
    longPressEvent = MobileLongPress(setMessageAnchorElement, setListIndex, setInboxMenuOptions, data, addArrData, arrData);
  }

  return (
    <List
      onClick={(e: any) => {
        if (data) {
          const index = [...e.currentTarget.childNodes].findIndex((el) => el === e.target.closest(".MuiListItem-root"));
          let newData: any = data[index];
          let isClickable = true;
          if (!isNullOrEmpty(newData.user) && ((newData.user.type === 1 && newData.user.followingStatus === UserStats.USER_HAS_BLOCKED_THE_LOGGED_IN_USER) || (newData.user.type === 2 && newData.user.followingStatus === StoreStats.STORE_HAS_BLOCKED_THE_USER))) {
            isClickable = false;
          }
          if (type === "chathistory" && isClickable && !isBrowser && arrData && arrData?.length > 0) {
            if (newData && arrData.indexOf(newData) !== -1) {
              let newArrData = arrData.filter((el) => el !== newData);
              addArrData(newArrData);
            } else {
              let newArrData = [...arrData, newData];
              addArrData(newArrData);
            }
            return;
          }
          if (isBrowser || (!isBrowser && (!arrData || (arrData && arrData?.length === 0)))) onListItemClick(e, type, userDetails, newData);
        }
      }}
    >
      {data &&
        data.map((v: any, i: number) => {
          const isSelected = arrData?.indexOf(v) !== -1;
          let backgroundColor = type === "chathistory" && isSelected ? "bg-bright-sky-blue" : "";
          if (type === "chathistory") {
            if (!isNullOrEmpty(v.user) && ((v.user.type === 1 && v.user.followingStatus === UserStats.USER_HAS_BLOCKED_THE_LOGGED_IN_USER) || (v.user.type === 2 && v.user.followingStatus === StoreStats.STORE_HAS_BLOCKED_THE_USER))) {
              longPressEvent = {};
            }
          }
          return (
            <ListItem className={`${type === "chathistory" && v.lastMessage.messageType !== 0 && "chathistory"}`} key={i} {...longPressEvent} disablePadding={true} sx={{ paddingRight: "0px" }} onMouseEnter={(e: any) => onListMouseEnter(e, type)} onMouseLeave={(e: any) => onListMouseLeave(e, type, clickedElement)}>
              <ListItemButton disableRipple={disableRipple} className={`pad-l-0 pad-r-0 pad-t-12 pad-b-12 ${backgroundColor}`}>
                {createListData(v, type, userDetails, actionCallback, connectivityStatus, isSelected)}
                {(type === "newchat" || type === "newchatrecent") && <Box className="cur-pot-none box-32 display-flex-justify-center">{(v.followingStatus === UserStats.BOTH_USERS_FOLLOW || (v.user && v.user.followingStatus === UserStats.BOTH_USERS_FOLLOW)) && icon({ iconName: "group", iconColor: "icon-spanish-gray", iconCustomClass: "trailIcon" })}</Box>}
                {createListSecondaryAction(type, v, state, data, userDetails, setMessageAnchorElement, setListIndex, i, setInboxMenuOptions, setClickedElement, setDisableRipple, secondaryActionWidth)}
              </ListItemButton>
            </ListItem>
          );
        })}
      {isBrowser && type === "chathistory" && messageAnchorElement && messageAnchorElement.index === listIndex && (
        <CreateMenu
          anchorElement={messageAnchorElement.target}
          setAnchorElement={setMessageAnchorElement}
          menuItemList={ReturnInboxMenuOptions(inboxMenuOptions, actionCallback)}
          ref={ref}
          onClose={() => {
            if (clickedElement) {
              clickedElement.closest(".chathistory").getElementsByClassName("more")[0].style.display = "none";
            }
            setClickedElement("");
          }}
        />
      )}
    </List>
  );
};

const createListData = (data: any, type: string, userDetails: any, actionCallback: any, connectivityStatus?: boolean | null, isSelected?: boolean) => {
  let singleData = data,
    primaryTypo: "body2" | "subtitle2" = "subtitle2",
    primaryColor = "text-secondary";
  if (type === "chathistory" || type === "newchatrecent") {
    if (data?.unReadMessages && data?.unReadMessages > 0 && type === "chathistory") {
      //primaryTypo = "subtitle2";
      primaryColor = "text-primary";
    }
    // if (type === "newchatrecent") {
    //   primaryTypo = "body2";
    // }
    singleData = data?.user;
  }

  let followingStatusText = "Following",
    primaryText = "";
  if (!isNullOrEmpty(singleData)) {
    if (type === "followingsearch" || type === "newchat") {
      // primaryTypo = type === "followingsearch" ? "subtitle2" : "body2";
      primaryColor = type === "followingsearch" ? "text-primary" : "text-modern-gray";
      primaryText = singleData?.nameTemp;
    } else {
      primaryText = singleData?.name;
      if (type === "newfollowers") {
        // primaryTypo = "subtitle2";
        primaryColor = "text-primary";
      } else if (type === "followingrecent") {
        // primaryTypo = "body2";
        primaryColor = "text-primary";
      }
    }
    switch (singleData.followingStatus) {
      case UserStats.NEITHER_USER_IS_FOLLOWING:
        followingStatusText = "You may know";
        break;
      case UserStats.BOTH_USERS_FOLLOW:
        followingStatusText = "Friends";
        break;
      case UserStats.USER_HAS_BLOCKED_THE_LOGGED_IN_USER:
        primaryText = "Account not found";
        break;
    }
  } else {
    primaryText = "Account not found";
  }

  return (
    <>
      <ListItemAvatar
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          windowPostMessage({ url: singleData.displayUsername, type: "redirect", entityType: singleData.type }, WEBSITE_PATH);
        }}
      >
        {createUserAvatar(singleData, type, data, actionCallback, userDetails, connectivityStatus, isSelected)}
      </ListItemAvatar>
      <ListItemText sx={{ pointerEvents: "none", paddingRight: `${type === "followingrecent" || type === "followingsearch" ? "16px" : "13px"}`, margin: "0px", flex: "1 !important" }} disableTypography primary={createPrimaryText(singleData, primaryTypo, primaryText, type, followingStatusText, primaryColor)} secondary={<>{createSecondaryText(data, type, userDetails)}</>} />
    </>
  );
};

const createListSecondaryAction = (type: string, data: any, state: any, allData: any, userDetails: any, setMessageAnchorElement: any, setListIndex: any, index: number, setInboxMenuOptions: any, setClickedElement: any, setDisableRipple?: any, secondaryActionWidth?: any) => {
  switch (type) {
    case "chathistory":
      const timeTypo = data?.unReadMessages && data?.unReadMessages > 0 ? "subtitle2" : "body2",
        timeColor = data?.unReadMessages && data?.unReadMessages > 0 ? "text-primary" : "text-secondary";
      return (
        <Box className="flex-row display-flex-center pos-rel" sx={{ justifyContent: "flex-end", width: secondaryActionWidth ? secondaryActionWidth : "unset" }}>
          {isBrowser && !isNullOrEmpty(data.user) && data.user.followingStatus !== UserStats.USER_HAS_BLOCKED_THE_LOGGED_IN_USER && (
            <IconButton
              className="more box-32"
              sx={{ display: "none" }}
              onClick={(e) => {
                e.stopPropagation();
                setInboxMenuOptions(data);
                setListIndex(index);
                setClickedElement(e.currentTarget);
                onShowOptions(e.currentTarget, index, setMessageAnchorElement);
              }}
            >
              {icon({ iconName: "more_vert" })}
            </IconButton>
          )}
          <Box className="flex-column flex-align-end">
            {data.lastMessage.messageType === 0 ? (
              <></>
            ) : (
              <>
                <Typography sx={{ pointerEvents: "none" }} variant={`${timeTypo}`} className={`timeTypo ${timeColor}`}>
                  {formatDate(data.lastActiveAt)}
                </Typography>
                {!isNullOrEmpty(data.user) && data.user.followingStatus !== UserStats.USER_HAS_BLOCKED_THE_LOGGED_IN_USER ? (
                  <>
                    <Box className="flex-row mar-t-2 flex-align-center newFollowers ht-20">
                      {data.user.followingStatus !== UserStats.USER_HAS_BLOCKED && data.user.isMuted ? icon({ iconName: "notifications_off", iconSize: "size-16", iconColor: "icon-modern-gray" }) : <></>}
                      {data.pinnedAt > 0 ? icon({ iconName: "keep", iconSize: "size-16", iconColor: "icon-modern-gray", iconCustomClass: "mar-l-8" }) : <></>}
                      {!isNullOrEmpty(data.user) && data.user.followingStatus === UserStats.USER_HAS_BLOCKED ? icon({ iconName: "block", iconSize: "size-16", iconColor: "icon-spanish-gray", iconCustomClass: "mar-t-2 mdc-soft-show mar-l-8 rotate90" }) : <></>}
                      {data.unReadMessages && data.unReadMessages > 0 ? data.user.isMuted ? <StyledBadgeNotificationMute className="mar-l-8" badgeContent={data.unReadMessages}></StyledBadgeNotificationMute> : <StyledBadgeNotification className="mar-l-8" badgeContent={data.unReadMessages}></StyledBadgeNotification> : <></>}
                    </Box>
                  </>
                ) : (
                  <Box className="flex-row mar-t-2 flex-align-center newFollowers ht-20">{data.unReadMessages && data.unReadMessages > 0 ? <StyledBadgeNotification className="mar-l-8" badgeContent={data.unReadMessages}></StyledBadgeNotification> : <></>}</Box>
                )}
              </>
            )}
          </Box>
        </Box>
      );
    case "newfollowers":
      return <ReturnButtonType data={data} state={state} allData={allData} userDetails={userDetails} setDisableRipple={setDisableRipple} />;
    default:
      return "";
  }
};

const ReturnInboxMenuOptions = (inboxMenuOptions: ChatHistory, callbackMenu: any) => {
  const arrMenu = [
    deleteMenuItem(() => {
      callbackMenu("delete", inboxMenuOptions);
    }),
  ];

  if (inboxMenuOptions.user?.followingStatus === UserStats.USER_HAS_BLOCKED) {
    arrMenu.push(
      unblockMenuItem(() => {
        if (inboxMenuOptions.user && inboxMenuOptions.user.usercodenumdynamic) windowPostMessage({ type: "userBlockUnblocked", ucnum: inboxMenuOptions.user.usercodenumdynamic, fullname: inboxMenuOptions.user.name, username: inboxMenuOptions.user.displayUsername, blockType: "unblock", callType: "inbox", entityType: inboxMenuOptions.user.type, data: inboxMenuOptions }, WEBSITE_PATH);
      })
    );
  } else {
    arrMenu.push(
      blockMenuItem(() => {
        if (inboxMenuOptions.user && inboxMenuOptions.user.usercodenumdynamic) windowPostMessage({ type: "userBlockUnblocked", ucnum: inboxMenuOptions.user.usercodenumdynamic, fullname: inboxMenuOptions.user.name, username: inboxMenuOptions.user.displayUsername, blockType: "block", callType: "inbox", entityType: inboxMenuOptions.user.type, data: inboxMenuOptions }, WEBSITE_PATH);
      })
    );
  }

  if (inboxMenuOptions.user?.isMuted) {
    arrMenu.unshift(
      unmuteMenuItem(() => {
        callbackMenu("unmute", inboxMenuOptions);
      })
    );
  } else {
    arrMenu.unshift(
      muteMenuItem(() => {
        callbackMenu("mute", inboxMenuOptions);
      })
    );
  }

  if (inboxMenuOptions.pinnedAt > 0) {
    arrMenu.unshift(
      unpinMenuItem(() => {
        callbackMenu("unpin", inboxMenuOptions);
      })
    );
  } else {
    arrMenu.unshift(
      pinMenuItem(() => {
        callbackMenu("pin", inboxMenuOptions);
      })
    );
  }

  return arrMenu;
};

const getMessagesCount = (isSeller: boolean, conversationID: string, callback: any) => {
  getAPIAsync(
    Provider.URLS.BASE_URL,
    Provider.API_URLS.GetMessageCount,
    { conversationID: encodeURIComponent(conversationID) },
    (response: any) => {
      callback && callback(response);
    },
    () => {
      windowPostMessage({ type: "snackMsg", snackMsg: resource.error }, isSeller ? SELLER_SITE_PATH : WEBSITE_PATH);
    }
  );
};

export const initializeConversation = (data: any, ucnum: string, openChat: boolean = true, isSeller: boolean = false, tabMessage: string = "") => {
  /*  
  STEP 1 - GetMessageCount - get the message count and status
  STEP 2 - GetConversationID - to check if the conversation is already present or not
  STEP 3 - InsertConversation - to insert the conversation
  STEP 4 - InsertMessage - to insert a blank message so that the conversation is active
  */
  data.entityType = data.type;
  if (!isNullOrEmpty(data.conversationID)) {
    if (isSeller || data.type === 2) {
      getMessagesCount(isSeller, data.conversationID, (responseMsg: any) => {
        if (openChat) {
          data.messageCount = responseMsg.data.count ? responseMsg.data.count : 0;
          windowPostMessage({ ...data, type: "ownconnection", conversationID: data.conversationID, tabMessage: tabMessage }, isSeller ? SELLER_SITE_PATH : WEBSITE_PATH);
        }
      });
    } else {
      if (openChat) {
        data.messageCount = 0;
        windowPostMessage({ ...data, type: "ownconnection", conversationID: data.conversationID, tabMessage: tabMessage }, isSeller ? SELLER_SITE_PATH : WEBSITE_PATH);
      }
    }
  } else {
    getAPIAsync(
      Provider.URLS.BASE_URL,
      Provider.API_URLS.GetConversationID,
      { ucnum1: data.usercodenum, ucnum2: ucnum },
      (response: any) => {
        if (!isNullOrEmpty(response.data.conversationID)) {
          if (isSeller || data.type === 2) {
            getMessagesCount(isSeller, response.data.conversationID, (responseMsg: any) => {
              if (openChat) {
                data.messageCount = responseMsg.data.count ? responseMsg.data.count : 0;
                data.status = !isNullOrEmpty(response.data.status) ? response.data.status : 1;
                windowPostMessage({ ...data, type: "ownconnection", conversationID: response.data.conversationID, tabMessage: tabMessage }, isSeller ? SELLER_SITE_PATH : WEBSITE_PATH);
              }
            });
          } else {
            if (openChat) {
              data.messageCount = 0;
              data.status = 1;
              windowPostMessage({ ...data, type: "ownconnection", conversationID: response.data.conversationID, tabMessage: tabMessage }, isSeller ? SELLER_SITE_PATH : WEBSITE_PATH);
            }
          }
        } else {
          data.messageCount = 0;
          data.status = isSeller || data.type === 2 ? 0 : 1;
          const lastActivityTime: number = new Date().getTime();

          postAPIAsync(
            Provider.URLS.BASE_URL,
            Provider.API_URLS.InsertConversation,
            { ucnum1: data.usercodenum, ucnum2: ucnum, conversationID: "", isActive: true, createdAt: lastActivityTime, lastActiveAt: 0, type: isSeller || data.type === 2 ? 2 : 1, status: isSeller || data.type === 2 ? 0 : 1 },
            (response: any) => {
              if (openChat) {
                windowPostMessage({ ...data, type: "ownconnection", conversationID: response.data, tabMessage: tabMessage }, isSeller ? SELLER_SITE_PATH : WEBSITE_PATH);
              } else {
                const messageID = UniqueID();
                const insertParams: any = {
                  id: UniqueID(),
                  messageID: messageID,
                  messageContent: Encrypt("dummy"),
                  messageType: 0,
                  conversationID: response.data,
                  sentAt: 0,
                  lastActivityTime: 0,
                  isRead: true,
                  recipientUcnum: decodeURIComponent(ucnum),
                };

                postAPIAsync(Provider.URLS.BASE_URL, Provider.API_URLS.InsertMessage, insertParams, () => {
                  const updateParams: any = {
                    conversationID: response.data,
                    lastActiveAt: 0,
                    lastMessageId: messageID,
                  };
                  putAPIAsync(Provider.URLS.BASE_URL, Provider.API_URLS.UpdateConversation, updateParams);
                });
              }
            },
            () => {
              if (openChat) {
                windowPostMessage({ type: "snackMsg", snackMsg: resource.error }, isSeller ? SELLER_SITE_PATH : WEBSITE_PATH);
              }
            }
          );
        }
      },
      () => {
        if (openChat) {
          windowPostMessage({ type: "snackMsg", snackMsg: resource.error }, isSeller ? SELLER_SITE_PATH : WEBSITE_PATH);
        }
      }
    );
  }
};

const onListItemClick = (e: any, type: string, userDetails: any, data: any) => {
  e.preventDefault();
  if (type === "followingsearch") {
    insertUserRecentActivity(userDetails ? userDetails.ucnum : "0", data.usercodenum, 1);
  }

  // if (type !== "chathistory" && type !== "newchatrecent" && type !== "newchat" && (data.displayUsername || (data.user && data.user.displayUsername))) {
  //   windowPostMessage({ url: data.displayUsername ? data.displayUsername : data.user.displayUsername, type: "redirect" }, WEBSITE_PATH);
  //   return;
  // }

  if (data) {
    if (data.user) {
      data.user.pinnedAt = data.pinnedAt;
      data.user.conversationID = data.conversationID;
      data.user.status = data.status;
      data = data.user;
    }
    if (!data.usercodenum) {
      data.usercodenum = data.ucnum1 === userDetails.ucnum ? data.ucnum2 : data.ucnum1;
    }
    initializeConversation(data, userDetails.ucnum);
  }
};

const onListMouseEnter = (e: any, type: string) => {
  if (type !== "chathistory" || !isBrowser || isNullOrEmpty(e) || isNullOrEmpty(e.currentTarget) || e.currentTarget.getElementsByClassName("more").length === 0) {
    return;
  }
  e.currentTarget.getElementsByClassName("more")[0].style.display = "inline-flex";
};

const onListMouseLeave = (e: any, type: string, clickedElement: any) => {
  if (type !== "chathistory" || !isBrowser || isNullOrEmpty(e) || isNullOrEmpty(e.currentTarget) || e.currentTarget.getElementsByClassName("more").length === 0) {
    return;
  }

  if (e.currentTarget && e.currentTarget.getElementsByClassName("more").length > 0) e.currentTarget.getElementsByClassName("more")[0].style.display = "none";

  if (clickedElement && clickedElement.closest(".chathistory")) {
    if (clickedElement.closest(".chathistory").getElementsByClassName("more").length > 0) clickedElement.closest(".chathistory").getElementsByClassName("more")[0].style.display = "inline-flex";
  }
};

const MobileLongPress = (setMessageAnchorElement: any, setListIndex: any, setInboxMenuOptions: any, data: any, addArrData: any, arrData?: ChatHistory[]) => {
  const onLongPress = (e: any) => {
    const index: number = [...e.target.parentNode.parentElement.children].indexOf(e.target.parentNode);
    const indexData: ChatHistory = data[index];

    setInboxMenuOptions(indexData);
    if (arrData && arrData.indexOf(indexData) === -1) {
      const historyData = [...arrData, indexData];
      addArrData(historyData);
    }
    setListIndex(index);
    onShowOptions(e.target, index, setMessageAnchorElement);
  };

  const defaultOptions = {
    shouldPreventDefault: false,
    delay: 1000,
  };

  return useLongPressMod(onLongPress, null, defaultOptions);
};

const onSuggestionCloseClick = (e: any, loginUcnum: string, clickUserDetails: SuggestedResponse, state: any, allData: SuggestedResponse[]) => {
  e.stopPropagation();
  e.preventDefault();
  postAPIAsync(
    Provider.URLS.BASE_URL,
    Provider.API_URLS.IgnoreEntity,
    {
      EntityCodeNum1: decodeURIComponent(loginUcnum),
      EntityCodeNum2: clickUserDetails.entityCodeNum,
    },
    () => {
      if (state !== undefined && state !== null) {
        const filtered = allData.filter((item: any) => {
          return item !== clickUserDetails;
        });
        state(filtered);
        windowPostMessage({ type: "clearSuggestion" }, WEBSITE_PATH);
      }
    },
    () => {
      windowPostMessage({ type: "snackMsg", snackMsg: resource.error }, WEBSITE_PATH);
    }
  );
};

const onDeleteRecentClick = (e: any, ucnum: string, data: any, actionCallback: any) => {
  e.stopPropagation();
  deleteUserRecentActivity(ucnum, data, 1, actionCallback);
};

const ReturnButtonType = ({ data, state, allData, userDetails, setDisableRipple }: any) => {
  let buttonTitle: string | null = null;
  switch (data.followingStatus) {
    case UserStats.NEITHER_USER_IS_FOLLOWING:
      buttonTitle = "Follow";
      break;
    case UserStats.USER_IS_FOLLOWING:
      buttonTitle = "Follow back";
      break;
    case UserStats.BOTH_USERS_FOLLOW:
      buttonTitle = "Message";
      break;
    default:
      buttonTitle = "";
      break;
  }
  return (
    <Button
      variant="contained"
      size="small"
      className={`small-btn ${data.followingStatus === UserStats.BOTH_USERS_FOLLOW ? "MuiButton-contained-tonal" : ""}`}
      onMouseDown={() => {
        setDisableRipple(true);
        setTimeout(() => setDisableRipple(false), 100);
      }}
      onClick={(e) => {
        e.stopPropagation();
        changeFollowStatus(e, data, state, userDetails ? userDetails.ucnum : "0", allData);
      }}
    >
      {buttonTitle}
    </Button>
  );
};

const changeFollowStatus = (e: any, data: any, state: any, ucnum: string, allData: any) => {
  e.preventDefault();
  e.stopPropagation();
  if (data.followingStatus === UserStats.BOTH_USERS_FOLLOW) {
    data.pinnedAt = 0;
    initializeConversation(data, ucnum);
    return;
  }

  postAPIAsync(
    Provider.URLS.BASE_URL,
    Provider.API_URLS.InsertFollowers,
    {
      ucnum: ucnum,
      entityCodeNum: data.usercodenum,
      entityCodeType: 1,
    },
    () => {
      if (state !== undefined && state !== null) {
        const filtered = allData.map((item: any) => {
          if (item === data) {
            item.followingStatus = UserStats.BOTH_USERS_FOLLOW;
            windowPostMessage({ type: "clearSuggestion" }, WEBSITE_PATH);
            windowPostMessage({ type: "changeFollowStatus3rdParty", status: UserStats.BOTH_USERS_FOLLOW, receiverID: decodeURIComponent(data.usercodenum) }, WEBSITE_PATH);
            initializeConversation(data, ucnum, false);
          }
          return item;
        });
        state(filtered);
      }
    },
    () => {
      windowPostMessage({ type: "snackMsg", snackMsg: resource.error }, WEBSITE_PATH);
    }
  );
};

const createUserAvatar = (userNameDetails: any, type: string, data: any, actionCallback: any, userDetails: any, connectivityStatus?: boolean | null, isSelected?: boolean) => {
  const bucketName: any = userNameDetails && userNameDetails.type === 1 ? USER_BUCKET_NAME : STORE_BUCKET_NAME;
  if (isNullOrEmpty(userNameDetails) || (!isNullOrEmpty(userNameDetails) && userNameDetails.followingStatus === UserStats.USER_HAS_BLOCKED_THE_LOGGED_IN_USER)) {
    let person: any = icon({ iconName: "person", iconColor: "icon-true-white" });
    if (!isNullOrEmpty(userNameDetails) && userNameDetails?.type === 2 && userNameDetails?.followingStatus === StoreStats.STORE_HAS_BLOCKED_THE_USER) {
      person = icon({ iconName: "storefront", iconColor: "icon-true-white" });
    }

    return <Box className={`box-48 bor-rad-50 mdc-typography--border flex-center bg-light-gray`}>{person}</Box>;
  }
  if (type === "chathistory" && userNameDetails.connectivityStatus && userNameDetails.connectivityTstamp === null && (isNullOrEmpty(connectivityStatus) || connectivityStatus) && userNameDetails.followingStatus === UserStats.BOTH_USERS_FOLLOW) {
    return (
      <Box className="pos-rel">
        {type === "chathistory" && !isBrowser && isSelected && <Box className="smallCheck bg-true-white cur-pot-none">{icon({ iconName: "check_circle", iconSize: "size-16", iconColor: "icon-primary-color", iconCustomClass: "material-symbols-rounded-filled" })}</Box>}
        <StyledBadgeActive overlap="circular" anchorOrigin={{ vertical: "bottom", horizontal: "right" }} variant="dot">
          <Avatar alt={userNameDetails.name} sx={{ bgcolor: userNameDetails.profilePhotoColor, width: 48, height: 48 }} src={`${IMAGE_RESIZE_PATH}${bucketName}/${userNameDetails.profilePhoto};preset=250`} />
        </StyledBadgeActive>
      </Box>
    );
  }

  return (
    <Box className="pos-rel">
      {type === "followingrecent" && (
        <IconButton
          className="smallClose"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDeleteRecentClick(e, userDetails.ucnum, data, actionCallback);
          }}
        >
          {icon({ iconName: "close", iconSize: "size-16", iconColor: "icon-spanish-gray" })}
        </IconButton>
      )}

      {type === "chathistory" && !isBrowser && isSelected && <Box className="smallCheck bg-true-white cur-pot-none">{icon({ iconName: "check_circle", iconSize: "size-16", iconColor: "icon-primary-color", iconCustomClass: "material-symbols-rounded-filled" })}</Box>}
      <Avatar alt={userNameDetails.name} sx={{ bgcolor: userNameDetails.profilePhotoColor, width: 48, height: 48 }} src={`${IMAGE_RESIZE_PATH}${bucketName}/${userNameDetails.profilePhoto};preset=250`} />
    </Box>
  );
};

const createPrimaryText = (singleData: any, primaryTypo: any, primaryText: string, type: string, followingStatusText: string, primaryColor: string) => {
  return (
    <Box className="flex-row align-items-center primaryText">
      {type !== "followingsearch" && type !== "newchat" ? (
        <Typography variant={primaryTypo} className={`${primaryColor}`} noWrap sx={{ height: `${isNullOrEmpty(singleData) ? "22px" : "unset"}` }}>
          {primaryText}
        </Typography>
      ) : (
        <Typography variant={primaryTypo} component="div" className={`${primaryColor}`} noWrap sx={{ height: `${isNullOrEmpty(singleData) ? "22px" : "unset"}` }} dangerouslySetInnerHTML={{ __html: primaryText }}></Typography>
      )}
      {type !== "followingsearch" ? (
        !isNullOrEmpty(singleData) && singleData.followingStatus !== UserStats.USER_HAS_BLOCKED_THE_LOGGED_IN_USER && singleData?.followers && singleData?.followers >= FOLLOWERS_LIMIT ? (
          icon({ iconName: "check_circle", iconSize: "size-16", iconCustomClass: "mar-l-8", iconColor: "icon-primary-color" })
        ) : (
          <></>
        )
      ) : (
        <Box className="mar-l-8 flex-row flex-align-center">
          <Typography className="text-secondary" variant="body2">
            &#8226;
          </Typography>
          <Typography className="mar-l-8 text-secondary" variant="body2">
            {followingStatusText}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

const createSecondaryText = (data: any, type: string, userDetails: any) => {
  let textColor = "text-secondary";
  let isBlock = false;
  if (type === "chathistory") {
    textColor = isNullOrEmpty(data.unReadMessages) || data.unReadMessages === 0 ? "text-secondary" : "text-modern-gray";
  }
  let secondaryText = null;
  const insertTimeStamp = new Date(data.followedTstamp).getTime() - new Date(data.followedTstamp).getTimezoneOffset() * 60000;
  switch (type) {
    case "newfollowers":
      secondaryText = resource.startedFollowingYou;
      textColor = "text-secondary";
      break;
    case "chathistory":
      data.lastMessage.messageContent = Decrypt(data.lastMessage.messageContent);
      if (!isNullOrEmpty(data.user) && data.user.type === 1 && data.user.followingStatus === UserStats.USER_HAS_BLOCKED_THE_LOGGED_IN_USER) {
        //secondaryText = resource.deliverPrivacySettings;
        textColor = "text-secondary";
        isBlock = true;
      }
      if (!isNullOrEmpty(data.user) && data.user.type === 2 && data.user.followingStatus === StoreStats.STORE_HAS_BLOCKED_THE_USER) {
        secondaryText = resource.storePrivacySettings;
        textColor = "text-secondary";
        isBlock = true;
      }
      if (!isNullOrEmpty(data.lastMessage.deletedBy) && (data.lastMessage.deletedBy.toLowerCase() === "both" || encodeURIComponent(data.lastMessage.deletedBy) === userDetails.ucnum)) {
        secondaryText = (
          <Box className="flex-center">
            {icon({ iconName: "delete", iconColor: textColor, iconSize: "size-16", iconCustomClass: "mar-r-4" })}
            <Typography variant="body2" className={`${textColor} italic clamp-1 pad-r-4`}>
              {data.lastMessage.recipientUcnum !== decodeURIComponent(userDetails.ucnum) ? `You deleted this message` : `Message deleted`}
            </Typography>
          </Box>
        );
      } else if (data.lastMessage.messageType !== 0) {
        if (!isNullOrEmpty(data.user) && data.user.followingStatus === UserStats.USER_HAS_BLOCKED) textColor = "text-secondary";
        if (data.lastMessage.messageType === 2 && data.lastMessage.messageContent && !data.lastMessage.messageContent.includes("waving-hand.png")) {
          secondaryText = icon({ iconName: "thumb_up", iconColor: "icon-safety-orange", iconSize: "size-24" });
        } else if (data.lastMessage.messageType === 3 && (!data.lastMessage.reactions || data.lastMessage.reactions.length === 0)) {
          secondaryText = encodeURIComponent(data.lastMessage.recipientUcnum) !== userDetails.ucnum ? "You shared a post" : "Shared a post";
        } else if (data.lastMessage.messageType === 4) {
          secondaryText = returnFormattedMessage(JSON.parse(data.lastMessage.messageContent).messageContent);
        } else {
          if ((data.lastMessage.messageType === 1 || data.lastMessage.messageType === 2) && data.lastMessage.messageContent) data.lastMessage.messageContent = replaceEmojiSizeForInbox(data.lastMessage.messageContent);
          secondaryText = returnFormattedMessage(data.lastMessage.messageContent);
        }
        if (data.lastMessage.reactions && data.lastMessage.reactions.length > 0) {
          secondaryText = returnReactionMessage(data.lastMessage.reactions, secondaryText, userDetails);
        }
      } else {
        secondaryText = !isNullOrEmpty(data.user) ? `Say hi to ${data.user.name}` : "";
      }
      break;
    default:
      secondaryText = isNullOrEmpty(data.displayUsername) ? (!isNullOrEmpty(data.user) ? data.user.displayUsername : "") : data.displayUsername;
      break;
  }

  let arrowIcon = null;
  if (data.user && data.user.followingStatus !== UserStats.USER_HAS_BLOCKED_THE_LOGGED_IN_USER && userDetails && !isNullOrEmpty(data.lastMessage.messageContent) && encodeURIComponent(data.lastMessage.recipientUcnum) !== userDetails.ucnum && data.lastMessage.messageType !== 0 && ((!isNullOrEmpty(data.lastMessage.deletedBy) && data.lastMessage.deletedBy.toLowerCase() !== "both" && encodeURIComponent(data.lastMessage.deletedBy) !== userDetails.ucnum) || isNullOrEmpty(data.lastMessage.deletedBy))) {
    arrowIcon = icon({ iconName: "done_all", iconColor: `${data.lastMessage.isRead ? "icon-primary-color" : "icon-refined-gray"}`, iconSize: "size-16", iconCustomClass: "mar-r-4" });
  }

  return (
    <Box className="flex-row mar-t-6 flex-align-center" sx={{ pointerEvents: "none" }}>
      {type === "chathistory" ? (
        data.isTyping ? (
          <Typography variant="caption" className="loading text-secondary">
            Typing
          </Typography>
        ) : (
          <Box className="flex-align-center">
            {!isNullOrEmpty(arrowIcon) && arrowIcon}
            {data.lastMessage.messageType === 2 && data.lastMessage.messageContent && !data.lastMessage.messageContent.includes("waving-hand.png") && (isNullOrEmpty(data.lastMessage.reactions) || data.lastMessage.reactions.length === 0) ? (
              secondaryText
            ) : !isBlock && !isNullOrEmpty(data.lastMessage.deletedBy) && (data.lastMessage.deletedBy.toLowerCase() === "both" || encodeURIComponent(data.lastMessage.deletedBy) === userDetails.ucnum) ? (
              secondaryText
            ) : (
              <Typography component="div" className={`${textColor} clamp-1`} variant="caption" dangerouslySetInnerHTML={{ __html: secondaryText }}></Typography>
            )}
          </Box>
        )
      ) : (
        <Typography variant="caption" className={`${textColor}`} noWrap>
          {secondaryText}
        </Typography>
      )}

      {type === "newfollowers" && (
        <Typography variant="caption" className="text-secondary" sx={{ marginLeft: "4px" }}>
          {formatDate(insertTimeStamp)}
        </Typography>
      )}
    </Box>
  );
};

const returnReactionMessage = (reactions: any, messageData: any, userDetails: any) => {
  if (reactions && reactions.length === 1) {
    if (reactions[0].ucnum === userDetails.ucnum) {
      return `You reacted ${Decrypt(reactions[0].reaction)}`; //to ${messageData}
    }
    return `Reacted ${Decrypt(reactions[0].reaction)}`; //to ${messageData}
  } else {
    const filtered = reactions.filter((item: any) => {
      return item.ucnum === decodeURIComponent(userDetails.ucnum);
    });
    return filtered ? `You reacted ${Decrypt(filtered[0].reaction)}` : ""; // to ${messageData}
  }
};

const insertUserRecentActivity = (ucnum: string, recentucnum: string, type: number) => {
  postAPIAsync(Provider.URLS.BASE_URL, Provider.API_URLS.RecentActivity, {
    ucnum: ucnum,
    recentUcnum: recentucnum,
    type: type,
  });
};

const deleteUserRecentActivity = (ucnum: string, data: any, type: number, actionCallback: any) => {
  deleteAPIAsync(
    Provider.URLS.BASE_URL,
    Provider.API_URLS.RecentActivity,
    {
      ucnum: ucnum,
      recentUcnum: data.usercodenum,
      type: type,
    },
    () => {
      if (actionCallback) {
        actionCallback(data);
      }
    },
    () => {
      windowPostMessage({ type: "snackMsg", snackMsg: resource.error }, WEBSITE_PATH);
    }
  );
};

const onShowOptions = (target: any, index: number, setMessageAnchorElement: any) => {
  setMessageAnchorElement({
    index: index,
    target: target,
  });
};

export default forwardRef(ListCards);

interface propsSuggestion {
  data: SuggestedResponse[] | null;
  state?: any;
  secondaryActionWidth?: string;
}

export const CardListForSuggestion = ({ data, state, secondaryActionWidth }: propsSuggestion) => {
  const { userDetails } = useContext<any>(UserDetailsContext);

  return (
    <List
      onClick={(e: any) => {
        if (data) {
          const index = [...e.currentTarget.childNodes].findIndex((el) => el === e.target.parentNode);
          onSuggestionListItemClick(e, data[index]);
        }
      }}
    >
      {data &&
        data.map((v: SuggestedResponse, i: number) => (
          <ListItem key={i} disablePadding={true} sx={{ paddingRight: "0px" }}>
            <ListItemButton className="pad-l-0 pad-r-0 pad-t-12 pad-b-12">
              <ListItemAvatar
                onClick={(e: any) => {
                  onSuggestionListItemClick(e, v);
                }}
              >
                {
                  <Box className="pos-rel">
                    <IconButton
                      className="smallClose"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onSuggestionCloseClick(e, userDetails.ucnum, v, state, data);
                      }}
                    >
                      {icon({ iconName: "close", iconSize: "size-16", iconColor: "icon-spanish-gray" })}
                    </IconButton>
                    <Avatar alt={v.fullName} sx={{ bgcolor: v.profilePhotoColor, width: 48, height: 48 }} src={`${IMAGE_RESIZE_PATH}${USER_BUCKET_NAME}/${v.profilePhoto};preset=250`} />
                  </Box>
                }
              </ListItemAvatar>
              <ListItemText sx={{ pointerEvents: "none", paddingRight: "13px", margin: "0px", flex: "1 !important" }} disableTypography primary={createSuggestionPrimaryText(v)} secondary={createSuggestionSecondaryText(v)} />
              {ReturnSuggestionButtonType(v, userDetails, state, data, secondaryActionWidth)}
            </ListItemButton>
          </ListItem>
        ))}
    </List>
  );
};

const ReturnSuggestionButtonType = (data: SuggestedResponse, userDetails: any, state: any, allData: SuggestedResponse[], secondaryActionWidth?: string) => {
  let buttonTitle: string | null = null;
  switch (data.suggestionType) {
    case "followback":
      buttonTitle = "Follow back";
      break;
    default:
      buttonTitle = "Follow";
      break;
  }
  return (
    <Box sx={{ width: secondaryActionWidth ? secondaryActionWidth : "unset" }}>
      <Button
        variant="contained"
        size="small"
        className="small-btn"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          changeSuggestionFollowStatus(e, data, state, userDetails.ucnum, allData);
        }}
      >
        {buttonTitle}
      </Button>
    </Box>
  );
};

const createSuggestionPrimaryText = (data: SuggestedResponse) => {
  return (
    <Box className="flex-row align-items-center primaryText">
      <Typography variant="subtitle2" className="text-secondary" noWrap sx={{ height: `${isNullOrEmpty(data) ? "22px" : "unset"}` }}>
        {data.fullName}
      </Typography>

      {data?.followers && data?.followers >= FOLLOWERS_LIMIT ? icon({ iconName: "check_circle", iconSize: "size-16", iconCustomClass: "mar-l-8", iconColor: "icon-primary-color" }) : <></>}
    </Box>
  );
};

const createSuggestionSecondaryText = (data: SuggestedResponse) => {
  let secondaryText = null;
  switch (data.suggestionType) {
    case "followback":
      secondaryText = "Follows you";
      break;
    case "followby":
      secondaryText = "Followed by";
      break;
    case "follow":
      secondaryText = "Follows";
      break;
    case "friendswith":
      secondaryText = "Friends with";
      break;
    default:
      secondaryText = "Follow";
      break;
  }
  return (
    <Box className="flex-row mar-t-6 flex-align-center" sx={{ pointerEvents: "none" }}>
      <Typography variant="caption" className="text-secondary" noWrap>
        {secondaryText}
      </Typography>

      {data.references && (
        <AvatarGroup className="mar-l-4">
          {data.references.map((v: Reference, index: number) => (
            <Avatar key={index} alt={`${v.referenceName}`} sx={{ bgcolor: v.referenceProfilePhotoColor, width: 16, height: 16, fontSize: "12px" }} src={`${IMAGE_RESIZE_PATH}${USER_BUCKET_NAME}/${v.referenceProfilePhoto};preset=250`} />
          ))}
        </AvatarGroup>
      )}
    </Box>
  );
};

const onSuggestionListItemClick = (e: any, data: SuggestedResponse) => {
  e.preventDefault();
  if (!isNullOrEmpty(data.url)) {
    windowPostMessage({ url: data.url, type: "redirect" }, WEBSITE_PATH);
  }
  return;
};

const changeSuggestionFollowStatus = (e: any, data: SuggestedResponse, state: any, ucnum: string, allData: SuggestedResponse[]) => {
  e.preventDefault();
  e.stopPropagation();

  postAPIAsync(
    Provider.URLS.BASE_URL,
    Provider.API_URLS.InsertFollowers,
    {
      ucnum: ucnum,
      entityCodeNum: data.entityCodeNum,
      entityCodeType: 1,
    },
    () => {
      if (!isNullOrEmpty(state)) {
        const filtered = allData.filter((item: any) => {
          return item !== data;
        });
        state(filtered);
        windowPostMessage({ type: "clearSuggestion" }, WEBSITE_PATH);
        windowPostMessage({ type: "changeFollowStatus3rdParty", status: UserStats.BOTH_USERS_FOLLOW, receiverID: decodeURIComponent(data.entityCodeNum) }, WEBSITE_PATH);
      }
    },
    () => {
      windowPostMessage({ type: "snackMsg", snackMsg: resource.error }, WEBSITE_PATH);
    }
  );
};

export const SetUserData = (usercodenum: string, userDetails: any, sessionId: string, setUserDetails: any, callBack?: any) => {
  const details: LoggedInUserDetails = {
    ucnum: usercodenum,
    senderDetails: userDetails,
    sessionID: sessionId,
  };
  setUserDetails(details);
  if (callBack) {
    callBack(details);
  }
};